<template>
  <div>
    <div class="pageloader is-active has-text-centered">
      <span class="title" v-html="$t('loading.licence')"></span>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    var colideeIds = this.readColideeIdUrlHashParams();
    this.$store.dispatch("changeLangue", colideeIds.langueColidee);
    if (colideeIds.idEntreprise && colideeIds.idPlateforme) {
      this.$store.dispatch("setIframeColidee", true);
    } else {
      this.$store.dispatch("setIframeColidee", false);
    }
    if (colideeIds) {
      this.$store.dispatch("setColideeIds", {
        idEntreprise: colideeIds.idEntreprise,
        idPlateforme: colideeIds.idPlateforme,
        idEventColidee: colideeIds.idEventColidee
      });
    }
    // on récupère un éventuel initSearch depuis l'URL et on le stocke dans le store state si il existe
    var initSearch = readinitSearchUrlHashParams();
    if (initSearch)
      this.$store.dispatch("setInitSearch", { initSearch: initSearch });
    else this.$store.dispatch("setInitSearch", { initSearch: "" });

    /* on récupère un éventuel token depuis l'URL et on le stocke dans le store state si il existe*/
    var tokenURL = readUrlHashParams();
    if (tokenURL) this.$store.dispatch("setTokenURL", { tokenURL: tokenURL });
    /* On teste si le token  est vide dans le store (vide = pas de token en URL ou pas de token en mémoire localstorage) - on  vire le gars vers APPYPACK*/
    if (!this.$store.getters.userToken) {
      window.location = process.env.URL_SSO_FRONT;
      return;
    } else {
      /* on fait une demande de récupération de user/me avec ce token de connexion 'mis à jour ou en mémoire'	*/
      this.$store.dispatch("requireAuth");
      return;
    }
  },
  methods: {
    readColideeIdUrlHashParams() {
      var idEntreprise = false;
      var idPlateforme = false;
      var idEventColidee = false;
      var langueColidee = "fr";
      var hashParam = window.location.href.split("?")[1];
      if (hashParam) {
        var params = hashParam.split("&");
        params.forEach(function(element) {
          var paramSet = element.split("=");
          if (paramSet[0] == "e") {
            idEntreprise = paramSet[1];
          }
          if (paramSet[0] == "p") {
            idPlateforme = paramSet[1];
          }
          if (paramSet[0] == "l") {
            langueColidee = paramSet[1];
          }
          if (paramSet[0] == "ev") {
            idEventColidee = paramSet[1];
          }
        });
      }
      return { idEntreprise, idPlateforme, langueColidee, idEventColidee };
    }
  }
};

function readUrlHashParams() {
  var tokenTrouve = false;
  var hashParam = window.location.href.split("?")[1];
  if (hashParam) {
    var params = hashParam.split("&");
    params.forEach(function(element) {
      var paramSet = element.split("=");
      if (paramSet[0] == "t") {
        tokenTrouve = paramSet[1];
      }
    });
  }
  return tokenTrouve;
}

function readinitSearchUrlHashParams() {
  var initSearchTrouve = false;
  var hashParam = window.location.href.split("?")[1];
  if (hashParam) {
    var params = hashParam.split("&");
    params.forEach(function(element) {
      var paramSet = element.split("=");
      if (paramSet[0] == "initSearch") {
        initSearchTrouve = paramSet[1];
      }
    });
  }
  return initSearchTrouve;
}
</script>

<style type="text/css" scoped>
.pageloader {
  background: #424a60;
}
</style>



// WEBPACK FOOTER //
// src/components/security/tokenLogin.vue